// extracted by mini-css-extract-plugin
export var formContainer = "_c6-0";
export var message = "_c6-1";